export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";